module.exports = __webpack_public_path__ + "img/Still-Thinking-Inspect-Medium.85ad6427.png";